module.exports = __webpack_public_path__ + "static/media/state-back-13.198e3176.jpg";